// GENERATED from the v0.9 archive (HenHouse_v0.9.zip) by a one-off port script, then
// maintained by hand. Conditions rewritten as typed data; evaluated by core/achievements.ts.
import type { AchievementDef } from './types';

export const ACHIEVEMENTS: readonly AchievementDef[] = [
  { id: 'FIRST_EGG', name: "First Egg!", category: 'eggs', hidden: false,
    condition: { t: 'eggsCollected', n: 1 },
    description: "Collect your very first egg.",
    flavor: "It begins. You cannot go back now." },
  { id: 'CENTURY_CLUTCH', name: "Century Club", category: 'eggs', hidden: false,
    condition: { t: 'eggsCollected', n: 100 },
    description: "Collect 100 eggs total.",
    flavor: "One hundred eggs. Your fridge weeps." },
  { id: 'THOUSAND_EGGS', name: "Egg Thousandaire", category: 'eggs', hidden: false,
    condition: { t: 'eggsCollected', n: 1000 },
    description: "Collect 1,000 eggs total.",
    flavor: "Your hens have filed for overtime." },
  { id: 'TEN_THOUSAND_EGGS', name: "Egg Mogul", category: 'eggs', hidden: false,
    condition: { t: 'eggsCollected', n: 10000 },
    description: "Collect 10,000 eggs total.",
    flavor: "The HOA has questions." },
  { id: 'HUNDRED_THOUSAND_EGGS', name: "Egg Baron", category: 'eggs', hidden: false,
    condition: { t: 'eggsCollected', n: 100000 },
    description: "Collect 100,000 eggs total.",
    flavor: "Local egg market: destabilized. Regional market: nervous." },
  { id: 'ONE_MILLION_EGGS', name: "Eggillionaire", category: 'eggs', hidden: false,
    condition: { t: 'eggsCollected', n: 1000000 },
    description: "Collect 1,000,000 eggs total.",
    flavor: "A million eggs. Your therapist has thoughts." },
  { id: 'TRICKLE', name: "Trickle", category: 'production', hidden: false,
    condition: { t: 'layRate', n: 1 },
    description: "Reach 1 egg per second.",
    flavor: "A trickle. But the ocean was once a trickle too. Probably." },
  { id: 'RESPECTABLE_FLOCK', name: "Respectable Flock", category: 'production', hidden: false,
    condition: { t: 'layRate', n: 10 },
    description: "Reach 10 eggs per second.",
    flavor: "Ten per second. You can hear them rolling." },
  { id: 'STARTER_FLOCK', name: "Starter Flock", category: 'hens', hidden: false,
    condition: { t: 'hens', n: 1 },
    description: "Own your first hen.",
    flavor: "One hen. One dream. Infinite chicken math." },
  { id: 'SMALL_FARM', name: "Small Farm", category: 'hens', hidden: false,
    condition: { t: 'hens', n: 5 },
    description: "Own 5 hens total.",
    flavor: "Five hens. You officially have a situation." },
  { id: 'PROPER_FLOCK', name: "Union Formed", category: 'hens', hidden: false,
    condition: { t: 'hens', n: 10 },
    description: "Own 10 hens total.",
    flavor: "The hens have elected a shop steward." },
  { id: 'FULL_COOP', name: "Full Coop", category: 'hens', hidden: false,
    condition: { t: 'hens', n: 15 },
    description: "Own 15 hens — every nesting box filled.",
    flavor: "Standing room only. The hens are not amused." },
  { id: 'HES_IN_CHARGE_NOW', name: "He's In Charge Now", category: 'roosters', hidden: false,
    condition: { t: 'roosters', n: 1 },
    description: "Own your first rooster.",
    flavor: "Dawn will never be the same." },
  { id: 'DAWN_CHORUS', name: "Dawn Chorus", category: 'roosters', hidden: false,
    condition: { t: 'crows', n: 10 },
    description: "Trigger 10 rooster crows.",
    flavor: "The neighbors have started keeping a log." },
  { id: 'ROOSTERS_PRIDE', name: "Rooster's Pride", category: 'roosters', hidden: false,
    condition: { t: 'crows', n: 100 },
    description: "Trigger 100 rooster crows.",
    flavor: "A hundred crows, a hundred mornings, one very enthusiastic rooster." },
  { id: 'PERPETUAL_DAWN', name: "Perpetual Dawn", category: 'roosters', hidden: false,
    condition: { t: 'crows', n: 1000 },
    description: "Trigger 1,000 rooster crows.",
    flavor: "Time is a flat circle of cock-a-doodle-doos." },
  { id: 'BREED_CURIOUS', name: "Breed Curious", category: 'diversity', hidden: false,
    condition: { t: 'breedTypes', n: 2 },
    description: "Own 2 different hen breeds.",
    flavor: "Variety is the spice of farming." },
  { id: 'STARTER_SET', name: "Starter Set", category: 'diversity', hidden: false,
    condition: { t: 'ownAllStarters' },
    description: "Own all starter hen breeds.",
    flavor: "The original four. Solid choices." },
  { id: 'EARLY_ADOPTER', name: "Early Adopter", category: 'diversity', hidden: false,
    condition: { t: 'ownTier', tier: 'EARLY', n: 1 },
    description: "Own your first early-tier breed.",
    flavor: "You went off the beaten hen path." },
  { id: 'STYLE_ICON', name: "Style Icon", category: 'diversity', hidden: false,
    condition: { t: 'breedTypes', n: 5 },
    description: "Own 5 different hen breeds.",
    flavor: "Your farm looks amazing." },
  { id: 'FIRST_COLLECTION', name: "First Collection", category: 'clicks', hidden: false,
    condition: { t: 'clicks', n: 1 },
    description: "Manually collect your first egg.",
    flavor: "Your hands have touched an egg." },
  { id: 'HUNDRED_CLICKS', name: "Hundred Clicks", category: 'clicks', hidden: false,
    condition: { t: 'clicks', n: 100 },
    description: "Manually collect 100 eggs.",
    flavor: "Calluses forming." },
  { id: 'THOUSAND_CLICKS', name: "Thousand Clicks", category: 'clicks', hidden: false,
    condition: { t: 'clicks', n: 1000 },
    description: "Manually collect 1,000 eggs.",
    flavor: "Your clicking finger has its own heartbeat." },
  { id: 'TEN_THOUSAND_CLICKS', name: "Ten Thousand Clicks", category: 'clicks', hidden: false,
    condition: { t: 'clicks', n: 10000 },
    description: "Manually collect 10,000 eggs.",
    flavor: "Consider a rubber thimble." },
  { id: 'GOLDEN_TOUCH', name: "Golden Touch", category: 'clicks', hidden: false,
    condition: { t: 'goldenClicked', n: 1 },
    description: "Collect your first golden egg.",
    flavor: "The golden egg. Legend speaks of this." },
  { id: 'STORM_CHASER', name: "Storm Chaser", category: 'clicks', hidden: false,
    condition: { t: 'goldenClicked', n: 10 },
    description: "Collect 10 golden eggs.",
    flavor: "You have a nose for gold." },
  { id: 'SILVER_SEEKER', name: "Silver Seeker", category: 'clicks', hidden: false,
    condition: { t: 'silverClicked', n: 1 },
    description: "Collect your first silver egg.",
    flavor: "It is not gold. But it is something." },
  { id: 'MIRACLE_BIRTH', name: "Miracle Birth", category: 'special_eggs', hidden: false,
    condition: { t: 'broodyHatches', n: 1 },
    description: "Hatch your first chicken from a broody hen.",
    flavor: "A free chicken. Miracles DO happen." },
  { id: 'HATCHERY', name: "Hatchery", category: 'special_eggs', hidden: false,
    condition: { t: 'broodyHatches', n: 5 },
    description: "Hatch 5 chickens from broody hens.",
    flavor: "You have mastered the broody arts." },
  { id: 'MASTER_BREEDER', name: "Master Breeder", category: 'special_eggs', hidden: false,
    condition: { t: 'broodyHatches', n: 10 },
    description: "Hatch 10 chickens from broody hens.",
    flavor: "Your hens breed with purpose." },
  { id: 'WHATS_THAT_SMELL', name: "What's That Smell?", category: 'special_eggs', hidden: false,
    condition: { t: 'rottenSeen', n: 1 },
    description: "Encounter your first rotten egg.",
    flavor: "Every farmer remembers their first. Unfortunately." },
  { id: 'CLEAN_SWEEP', name: "Clean Sweep", category: 'special_eggs', hidden: false,
    condition: { t: 'rottenSalvaged', n: 3 },
    description: "Salvage 3 rotten eggs before they stink up the coop.",
    flavor: "Nose like a bloodhound, reflexes like a cat." },
  { id: 'BAD_DAY', name: "Bad Day", category: 'special_eggs', hidden: false,
    condition: { t: 'rottenExpired', n: 1 },
    description: "Let a rotten egg expire naturally.",
    flavor: "The stench. The penalty. The shame." },
  { id: 'FREE_ROOSTER', name: "Free Rooster", category: 'special_eggs', hidden: false,
    condition: { t: 'roosterEggsHatched', n: 1 },
    description: "Hatch a rooster from an egg.",
    flavor: "You did not even buy that." },
  { id: 'SPEED_RUNNER', name: "Speed Runner", category: 'secret', hidden: true,
    condition: { t: 'eggsInWindow', n: 100, seconds: 120 },
    description: "Collect 100 eggs within any two-minute span.",
    flavor: "Quick fingers. Caffeinated." },
  { id: 'THOUSAND_IN_FIVE', name: "Thousand in Five", category: 'secret', hidden: true,
    condition: { t: 'eggsInWindow', n: 1000, seconds: 300 },
    description: "Collect 1,000 eggs within any five-minute span.",
    flavor: "This farm runs hot." },
  { id: 'NIGHT_OWL', name: "Night Owl", category: 'secret', hidden: true,
    condition: { t: 'lateNight' },
    description: "Play the game during midnight hours.",
    flavor: "The hens are confused. So am I." },
  { id: 'ONE_MORE_THING', name: "One More Thing", category: 'secret', hidden: true,
    condition: { t: 'almostAfford3' },
    description: "Be within 5% of affording three different upgrades at once.",
    flavor: "So close. So very close." },
  { id: 'WARM_AND_FLUFFY', name: "Warm and Fluffy", category: 'comedy', hidden: false,
    condition: { t: 'broodyHatches', n: 5 },
    description: "Hatch 5 chickens from broody hens.",
    flavor: "You have become one with the broody arts." },
  { id: 'CLOUD_COMPANION', name: "Cloud Companion", category: 'comedy', hidden: false,
    condition: { t: 'ownBreed', breed: 'SILKIE', n: 1 },
    description: "Welcome a Silkie into your coop.",
    flavor: "Soft as a hug. Gentle as morning. The most beloved bird in your coop." },
  { id: 'CURLY_CHAMPION', name: "Curly Champion", category: 'comedy', hidden: false,
    condition: { t: 'ownBreed', breed: 'FRIZZLE', n: 1 },
    description: "Welcome a Frizzle into your coop.",
    flavor: "Every feather a tiny celebration. She walks on sunshine." },
  { id: 'CLOUD_CATHEDRAL', name: "Cloud Cathedral", category: 'comedy', hidden: false,
    condition: { t: 'ownBreed', breed: 'SILKIE', n: 15 },
    description: "Fill an entire flock with 15 Silkies.",
    flavor: "Fifteen pillows of pure peace. The softest coop in the world." },
  { id: 'FOREVER_FRIZZLED', name: "Forever Frizzled", category: 'comedy', hidden: false,
    condition: { t: 'ownBreed', breed: 'FRIZZLE', n: 15 },
    description: "Fill an entire flock with 15 Frizzles.",
    flavor: "Every feather points its own way. Beautiful chaos, perfectly arranged." },
  { id: 'BROODY_BUILD', name: "Full Nursery", category: 'flock_build', hidden: false,
    condition: { t: 'flockAllBroodyProne', n: 15 },
    description: "Own a flock of 15 broody-prone hens with a rooster.",
    flavor: "She's been sitting on this nest so long she's forgotten what grass looks like." },
  { id: 'BROODY_SWARM', name: "Broody Swarm", category: 'broody', hidden: false,
    condition: { t: 'concurrentBroody', n: 10 },
    description: "Have 10 hens broody at the same time.",
    flavor: "Every nest is a war zone of fluffy determination." },
  { id: 'EPS_ENGINE', name: "Full Assembly Line", category: 'flock_build', hidden: false,
    condition: { t: 'flockNoneBroodyProne', n: 15 },
    description: "Own a flock of 15 non-broody-prone hens with a rooster.",
    flavor: "The nests never stop. Neither do the hens." },
  { id: 'SECOND_COOP', name: "Second Coop", category: 'multi_flock', hidden: false,
    condition: { t: 'roosters', n: 2 },
    description: "Own your second rooster — multi-flock begins.",
    flavor: "One rooster was ambition. Two is a farm." },
  { id: 'TRINITY', name: "Trinity Farm", category: 'multi_flock', hidden: false,
    condition: { t: 'roosters', n: 3 },
    description: "Run 3 roosters simultaneously.",
    flavor: "Three crows at dawn. The neighbors have started journaling." },
  { id: 'SEVEN_SPIRES', name: "Seven Spires", category: 'multi_flock', hidden: false,
    condition: { t: 'roosters', n: 7 },
    description: "Run 7 roosters simultaneously — deep multi-flock.",
    flavor: "An audible empire. Seven morning alarm clocks, none of which you can silence." },
  { id: 'APEX', name: "Apex Coop Operator", category: 'multi_flock', hidden: false,
    condition: { t: 'roosters', n: 10 },
    description: "Reach the ladder ceiling: 10 active roosters.",
    flavor: "Ten flocks. Ten roosters. One very tired farmer with ten coffee mugs." },
  { id: 'FAST_APEX', name: "Speedrunner", category: 'multi_flock', hidden: true,
    condition: { t: 'roostersWithin', n: 10, seconds: 345600 },
    description: "Reach 10 roosters within 4 days of starting the farm.",
    flavor: "You treated this like a job. A very specific, feathered job." },
  { id: 'ALL_RIR', name: "All Things RIR", category: 'flock_build', hidden: false,
    condition: { t: 'ownBreed', breed: 'RIR', n: 15 },
    description: "Fill an entire flock with 15 Rhode Island Reds.",
    flavor: "The chicken that built America. Now filling an entire coop." },
  { id: 'ALL_LEGHORN', name: "White Lightning", category: 'flock_build', hidden: false,
    condition: { t: 'ownBreed', breed: 'LEGHORN', n: 15 },
    description: "Fill an entire flock with 15 Leghorns.",
    flavor: "Your neighbors have filed 12 noise complaints. The 13th is pending." },
  { id: 'ALL_BUFF', name: "Golden Meadow", category: 'flock_build', hidden: false,
    condition: { t: 'ownBreed', breed: 'BUFF_ORPINGTON', n: 15 },
    description: "Fill an entire flock with 15 Buff Orpingtons.",
    flavor: "A flock that could tuck in its own eggs." },
  { id: 'ALL_AYAM', name: "Obsidian Cathedral", category: 'flock_build', hidden: false,
    condition: { t: 'ownBreed', breed: 'AYAM_CEMANI', n: 15 },
    description: "Fill an entire flock with 15 Ayam Cemani.",
    flavor: "Blackbone hens from comb to claw. This is not a flock; this is a mood." },
  { id: 'ALL_SULTAN', name: "Royal Court", category: 'flock_build', hidden: false,
    condition: { t: 'ownBreed', breed: 'SULTAN', n: 15 },
    description: "Fill an entire flock with 15 Sultans.",
    flavor: "Crests, muffs, vulture hocks — 75 feet, 15 beards, one absolute throne room." },
  { id: 'ALL_POLISH', name: "Hair Bands", category: 'flock_build', hidden: false,
    condition: { t: 'ownBreed', breed: 'POLISH', n: 15 },
    description: "Fill an entire flock with 15 Polish.",
    flavor: "Fifteen crests. Fifteen perms. Fifteen hens who don't know what year it is." },
  { id: 'RAINBOW_FLOCK', name: "Rainbow Flock", category: 'flock_build', hidden: false,
    condition: { t: 'flockDistinctBreeds', n: 15 },
    description: "Place 15 different breeds in a single flock.",
    flavor: "First-of-kind stacked fifteen ways. Every hen is the MVP of her shift." },
  { id: 'APEX_FLOCK', name: "Apex Flock", category: 'flock_build', hidden: false,
    condition: { t: 'flockTier', tier: 'RARE', n: 15 },
    description: "Place 15 RARE-tier hens in a single flock.",
    flavor: "Can't go to the fair anymore. Too many judges have questions." },
  { id: 'TYPE_IN_TYPE', name: "Five Specialists", category: 'flock_build', hidden: false,
    condition: { t: 'homogeneousFlocks', n: 5 },
    description: "Run 5 flocks, each all one breed (different breed per flock).",
    flavor: "The dedication tab at your farm is overflowing. So are the dedicated henhouses." },
  { id: 'RIR_DYNASTY', name: "RIR Dynasty", category: 'synergy', hidden: false,
    condition: { t: 'matchedPair', breed: 'RIR', n: 10 },
    description: "Run a flock with an RIR rooster and 10+ RIR hens.",
    flavor: "They've formed a union, elected officers, and are negotiating for covered parking." },
  { id: 'CHOCOLATE_FACTORY', name: "Chocolate Factory", category: 'synergy', hidden: false,
    condition: { t: 'matchedPair', breed: 'BLACK_COPPER_MARANS', n: 10 },
    description: "Run a flock with a BCM rooster and 10+ BCM hens.",
    flavor: "Darker than the eggs they produce. Click storm fuel." },
  { id: 'GOLDEN_DAWN', name: "Golden Dawn", category: 'synergy', hidden: false,
    condition: { t: 'matchedPair', breed: 'WELSUMMER', n: 10 },
    description: "Run a flock with a Welsummer rooster and 10+ Welsummer hens.",
    flavor: "The chocolate-brown eggs come out still glowing faintly." },
  { id: 'CLEAN_PAIR_X5', name: "Five Clean Pairs", category: 'synergy', hidden: false,
    condition: { t: 'matchedPairFlocks', n: 5 },
    description: "Run 5 flocks, each with a matching rooster+hen of the same breed.",
    flavor: "Five roosters. Five flocks. Five very small, very specific family trees." },
  { id: 'ROOSTER_LAB', name: "Rooster Lab", category: 'synergy', hidden: false,
    condition: { t: 'uniqueRoosterBreedsInFlocks', n: 10 },
    description: "Run 10 flocks, each with a distinct rooster breed.",
    flavor: "A taxonomic miracle. One of every kind, all crowing on their own schedule." },
  { id: 'CROW_CHORUS', name: "Choral Arrangement", category: 'roosters', hidden: false,
    condition: { t: 'crows', n: 5000 },
    description: "Trigger 5,000 rooster crows.",
    flavor: "Your farm is no longer a farm. It's a concert venue." },
  { id: 'BROOD_SHEPHERD', name: "Brood Shepherd", category: 'broody', hidden: false,
    condition: { t: 'broodyHatches', n: 500 },
    description: "Complete 500 broody sessions.",
    flavor: "The chicks call you mama. All of them. Forever." },
  { id: 'RAINBOW_MASTER', name: "Rainbow Master", category: 'eggs', hidden: false,
    condition: { t: 'rainbowClicked', n: 100 },
    description: "Click 100 rainbow eggs.",
    flavor: "Every shade. Every time. You've seen all the colors." },
  { id: 'SPEEDRUN_R5', name: "Early Bird", category: 'multi_flock', hidden: false,
    condition: { t: 'roostersWithin', n: 5, seconds: 108000 },
    description: "Own 5 roosters within 30 hours of starting the farm.",
    flavor: "The coop at dawn, the empire by lunch." },
  { id: 'STARTER_PURISM', name: "Starter Purism", category: 'flock_build', hidden: false,
    condition: { t: 'postWinFlockTier', tier: 'STARTER', n: 15 },
    description: "After earning $1M, run a flock of 15 STARTER-tier hens.",
    flavor: "Nobody fancy. Just 15 reliable birds, doing what they do." },
  { id: 'ALL_BRAHMA', name: "Colossus Coop", category: 'flock_build', hidden: false,
    condition: { t: 'ownBreed', breed: 'BRAHMA', n: 15 },
    description: "Fill an entire flock with 15 Brahma.",
    flavor: "Each bird the size of a small dog. The coop is structural now." },
  { id: 'ALL_COCHIN', name: "Cloud Nine", category: 'flock_build', hidden: false,
    condition: { t: 'ownBreed', breed: 'COCHIN', n: 15 },
    description: "Fill an entire flock with 15 Cochin.",
    flavor: "It is all fluff. There is no chicken in there. Only fluff." },
  { id: 'ALL_WYANDOTTE', name: "Silver Fleet", category: 'flock_build', hidden: false,
    condition: { t: 'ownBreed', breed: 'WYANDOTTE', n: 15 },
    description: "Fill an entire flock with 15 Wyandotte.",
    flavor: "Laced, calm, and waiting for the rooster to double the silver rate." },
  { id: 'ALL_AUSTRALORP', name: "Onyx Uniform", category: 'flock_build', hidden: false,
    condition: { t: 'ownBreed', breed: 'AUSTRALORP', n: 15 },
    description: "Fill an entire flock with 15 Australorp.",
    flavor: "Fifteen birds. Fifteen world records. Fifteen very smug expressions." },
  { id: 'ALL_PLYMOUTH', name: "Striped Parade", category: 'flock_build', hidden: false,
    condition: { t: 'ownBreed', breed: 'PLYMOUTH_ROCK', n: 15 },
    description: "Fill an entire flock with 15 Plymouth Rock.",
    flavor: "Rows of black-and-white bars. Very patriotic. Very utility." },
  { id: 'ALL_EASTER_EGGER', name: "Pastel Brigade", category: 'flock_build', hidden: false,
    condition: { t: 'ownBreed', breed: 'EASTER_EGGER', n: 15 },
    description: "Fill an entire flock with 15 Easter Eggers.",
    flavor: "Fifteen different shades of not-quite-white. Your nests look like an egg painting." },
  { id: 'SILVER_PROSPECTOR', name: "Silver Prospector", category: 'synergy', hidden: false,
    condition: { t: 'matchedPair', breed: 'WYANDOTTE', n: 10 },
    description: "Run a flock with a Wyandotte rooster and 10+ Wyandotte hens.",
    flavor: "Double the silver. Double the squinting." },
  { id: 'BLOOM_GARDEN', name: "Bloom Garden", category: 'synergy', hidden: false,
    condition: { t: 'matchedPair', breed: 'MILLE_FLEUR_DUCCLE', n: 10 },
    description: "Run a flock with a Mille Fleur D'Uccle rooster and 10+ MFD hens.",
    flavor: "Bloom eggs on a one-minute cadence. The nest looks like a florist's." },
  { id: 'POLISH_COURT', name: "Polish Court", category: 'synergy', hidden: false,
    condition: { t: 'matchedPair', breed: 'POLISH', n: 10 },
    description: "Run a flock with a Polish rooster and 10+ Polish hens.",
    flavor: "A sea of crests. Nobody can see. Nobody seems to mind." },
  { id: 'WARMTH_COVEN', name: "Warmth Coven", category: 'broody', hidden: false,
    condition: { t: 'roosterWithAllBroodyProne', rooster: 'COCHIN', n: 15 },
    description: "Run a flock with a Cochin rooster and 15 all-broody-prone hens.",
    flavor: "Every hen wants to sit on every nest. Order is a suggestion." },
  { id: 'DAWN_TO_DUSK', name: "Dawn to Dusk", category: 'multi_flock', hidden: false,
    condition: { t: 'activePlay', seconds: 43200 },
    description: "Rack up 12 hours of active play in a single run.",
    flavor: "The sun rose. The sun set. The chickens kept laying." },
  { id: 'FULL_WEEK', name: "Full Week Harvester", category: 'multi_flock', hidden: false,
    condition: { t: 'lifetimeActivePlay', seconds: 604800 },
    description: "Accumulate 168 hours of active play across all runs.",
    flavor: "A week with the flock. You can tell their moods by the noise." },
  { id: 'CROW_COLOSSEUM', name: "Crow Colosseum", category: 'roosters', hidden: false,
    condition: { t: 'crows', n: 10000 },
    description: "Trigger 10,000 rooster crows.",
    flavor: "The neighbors have formed a small, well-organized mob." },
  { id: 'BROOD_SAINT', name: "Brood Saint", category: 'broody', hidden: false,
    condition: { t: 'broodyHatches', n: 2000 },
    description: "Complete 2,000 broody sessions.",
    flavor: "Canonized by the Society of Broody Hens. Stained glass and all." },
  { id: 'GOLDEN_FLOOD', name: "Golden Flood", category: 'special_eggs', hidden: false,
    condition: { t: 'goldenClicked', n: 500 },
    description: "Click 500 golden eggs.",
    flavor: "It's raining gold. It's raining shells. Your cursor is exhausted." },
  { id: 'ROOSTER_VARIETY_PACK', name: "Rooster Variety Pack", category: 'roosters', hidden: false,
    condition: { t: 'roosterBreedsEver', n: 15 },
    description: "Own 15 distinct rooster breeds across your runs.",
    flavor: "Every crow a different instrument. The morning symphony is complete." },
];
